import * as React from "react";

interface ButtonProps {
  type?: "button" | "submit";
  variant: "secondary" | "danger" | "primary" | "reply";
  onClick?: (e: any) => void;
  disabled?: boolean;
  className?: string;
  autoFocus?: boolean;
}

class Button extends React.Component<ButtonProps, {}> {
  render() {
    let { variant, type, className, ...rest } = this.props;

    type = type || "button";
    className = `velaro-btn ${variant} ${className}`;

    return (
      <button className={className} type={type} {...rest}>
        {this.props.children}
      </button>
    );
  }
}

export default Button;
